import React, {useState, useEffect} from "react";
import style from "styled-components";
import {styled} from "@mui/system";
import Button from "@mui/material/Button";
import {useEthers} from "@usedapp/core";
import {IoIosArrowDown} from "react-icons/io";
import ConnectWalletModal from "../ConnectWalletModal";

function StackingConnectWallet() {
  const [activateError, setActivateError] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [walletModal, setWalletModal] = useState(false);
  const {account, deactivate, error, activateBrowserWallet} = useEthers();

  const handleOpenModal = () => {
    setWalletModal(!walletModal);
  };
  useEffect(() => {
    if (error) {
      setActivateError(error.message);
    }
  }, [error]);
  return (
    <Wrapper>
      {!account ? (
        <>
          <>
            {walletModal && (
              <ConnectWalletModal
                walletModal={walletModal}
                setWalletModal={setWalletModal}
              />
            )}
          </>

          <FirstConnectButton variant="contained" onClick={handleOpenModal}>
            Connect Wallet
          </FirstConnectButton>
        </>
      ) : (
        <>
          {activateError === "" ? (
            <ConnectButton
              onClick={() => setIsVisible(!isVisible)}
              variant="contained"
            >
              <span>
                {account.slice(0, 6)}...
                {account.slice(account.length - 3)}
              </span>
              <div>
                <IoIosArrowDown />
              </div>
            </ConnectButton>
          ) : (
            <ErrorButton variant="contained">Unsupported Chain</ErrorButton>
          )}

          {isVisible && (
            <DisconnectButton variant="contained" onClick={() => deactivate()}>
              Disconnect
            </DisconnectButton>
          )}
        </>
      )}
    </Wrapper>
  );
}

export default StackingConnectWallet;

const Wrapper = style.div`
  display: flex;
  flex-direction: column;
  position: relative;
  @media (max-width: 768px) {
    flex-direction: row;
  }
`;

const DisconnectButton = styled(Button)`
  border: 2px solid red;
  box-shadow: rgb(237 30 255 / 50%) 0px 0px 10px;
  margin-right: -0.3rem;
  width: 10rem !important;
  font-weight: 500;
  background-color: #0000007f !important;
  backdrop-filter: blur(15px);
  position: absolute;
  top: 3.5rem;
  &:hover {
    background: none;
    opacity: 0.8;
  }
  @media (max-width: 768px) {
    margin-right: 1rem;
  }
`;

const FirstConnectButton = styled(Button)`
  display: flex;
  gap: 0.4rem;
  background: none;
  margin-right: -0.3rem;
  border: 2px solid red;
  box-shadow: rgb(237 30 255 / 50%) 0px 0px 10px;
  font-weight: 500;
  width: auto !important;
  text-transform: uppercase;
  &:hover {
    background: none;
    opacity: 0.8;
  }
  @media (max-width: 768px) {
    margin-right: 1rem;
  }
`;

const ConnectButton = styled(Button)`
  display: flex;
  gap: 0.4rem;
  background: none;
  margin-right: -0.3rem;
  border: 2px solid red;
  box-shadow: rgb(237 30 255 / 50%) 0px 0px 10px;
  font-weight: 500;
  width: 10rem !important;
  &:hover {
    background: none;
    opacity: 0.8;
  }
  @media (max-width: 768px) {
    margin-right: 1rem;
  }
`;
const ErrorButton = styled(Button)`
  padding: 0.8rem 1rem;
  margin-right: -0.3rem;
  font-size: 1rem;
  font-weight: 500;
  background: rgba(221, 25, 39, 0.2);
  border-radius: 1.5rem;
  color: #fff;
  border: 2px solid rgba(221, 25, 39, 1);
  box-shadow: 0 0 2px rgb(221 25 39 / 50%);
`;
